import IConstraints from '../../../../../types/IContraints';
import { IValidator } from './IValidator';

export const Constraint = {
  MAX_LENGTH: 'max-length',
  MIN_LENGTH: 'min-length',
  PATTERN: 'pattern',
  REQUIRED: 'required',
} as const;

export default class Validator implements IValidator {
  // Validators
  public static maxlengthValidator(value: any, maxLength: number): boolean {
    return !value || value.length <= maxLength;
  }

  public static requiredValidator(value: any, required: boolean): boolean {
    if (required) {
      if (typeof value === 'undefined' || value === '' || value === null) {
        return false;
      }
    }

    return true;
  }

  public static minlengthValidator(value: any, minLength: number) {
    return !value || value.length >= minLength;
  }

  public static patternValidator(value: string, pattern: string) {
    return new RegExp(pattern).test(value);
  }

  private _constraints: IConstraints;

  constructor(constraints: IConstraints) {
    this._constraints = constraints;
  }

  public validate(value: any, constraints: IConstraints = this._constraints): any[] {
    const issues: any[] = [];

    if (constraints.minLength && Validator.minlengthValidator(value, constraints.minLength) === false) {
      issues.push(Constraint.MIN_LENGTH);
    }

    if (constraints.maxLength && Validator.maxlengthValidator(value, constraints.maxLength) === false) {
      issues.push(Constraint.MAX_LENGTH);
    }

    if (constraints.pattern && Validator.patternValidator(value, constraints.pattern) === false) {
      issues.push(Constraint.PATTERN);
    }

    if (constraints.required && Validator.requiredValidator(value, constraints.required) === false) {
      issues.push(Constraint.REQUIRED);
    }

    return issues;
  }
}
